import React, { FC, useCallback } from 'react';
import { ActionButton } from '@manulife/mux';
import { Edit, Eye1 } from '@manulife/mux-cds-icons';
import { mqLabel } from './card.utils';
import { CardVariant, ProductCardGenericLabels } from './ProductCard';

export const MQButton: FC<{
  isMqTaken: boolean;
  paxId: number;
  mqAction: (paxId: number, action: string) => void;
  genericLabels: ProductCardGenericLabels;
  id: string;
  variant?: CardVariant;
}> = ({ isMqTaken, paxId, mqAction, genericLabels, id, variant }) => {
  const clickHandler = useCallback(
    e => {
      e.preventDefault();
      mqAction(paxId, isMqTaken ? 'EDIT_MQ' : 'TAKE_MQ');
    },
    [paxId, isMqTaken, mqAction]
  );
  return (
    <ActionButton
      icon={isMqTaken ? <Eye1 /> : <Edit />}
      className="mx-auto p-0 my-2"
      id={id}
      data-testid={id}
      onClick={clickHandler}
    >
      {mqLabel(isMqTaken, genericLabels)}
    </ActionButton>
  );
};
MQButton.displayName = 'MQButton';
export default MQButton;
